import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, Inject, ViewChild } from '@angular/core';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { EventsService } from 'app/services/events/events.service';
import { Utils } from 'app/components/utils/Utils';
import { ReservationModel } from 'app/models/reservation-model';
import { Constants } from 'app/components/utils/Constants';
import { TypePassword } from 'app/models/order-password-model';
import { Cart, ItemCart, UserData } from 'app/models/cart-model';
import { InfoCart, ItemInfoCart } from 'app/models/info-cart-model';
import * as moment from 'moment';
import { StockModel, Type } from 'app/models/stock-model';
import { FieldFilter, OperatorFilterEnum } from 'app/models/filter-model';
import { LoaderService } from 'app/services/loader/Loader.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CalculatePeriods } from 'app/models/calculate-periods-model';
import { PaymentModel } from 'app/models/payment-model';
import { ActivityModel } from 'app/models/activity-mode';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SimpleDialogComponent } from 'app/components/shared/dialog/simple-dialog/simple-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MassiveActions } from 'app/components/shared/filters/filter.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom, Subscription } from 'rxjs';
import { Log } from 'app/core/logging/log';
import { RefundModel } from 'app/models/refund-model';
import { CategoryModel } from 'app/models/category-model';
import { OrderLineDto, ReservationDetailsDto } from 'app/models/reservation-details-model';
import { DataTableSelectionConfig } from 'app/components/shared/data-table/data-table.component';
import { DataTableBadgeTone } from 'app/components/shared/data-table/data-table-badge.component';
import { ConfigService } from 'app/services/config/config.service';
import { AdminSenderPage } from '../admin-sender/admin-sender.page';
import { SharedModule } from 'app/shared.module';
import { AdminSenderPageModule } from '../admin-sender/admin-sender.module';


@Component({
  selector: 'app-admin-reservation',
  templateUrl: './admin-reservation.page.html',
  styleUrls: ['./admin-reservation.page.scss'],
})
export class AdminReservationPage implements OnInit {
  state: 'idle' | 'loading' | 'loaded' | 'error' = 'idle';
  //Table
  selectedRows: ReservationModel[];
  dataSource = new MatTableDataSource<ReservationModel>;
  displayedColumns = ['select', 'lockerId', 'reference', 'status', 'type', 'date', 'notice'];
  selection = new SelectionModel<ReservationModel>(true, []);
  readonly selectionColumnConfig: DataTableSelectionConfig<ReservationModel> = {
    selection: this.selection,
    canSelect: (row) => this.validationAction(row)
  };

  //Paginator
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalElements: number = 50;
  pageSize = 25;
  pageIndex = 0;

  //Filter
  fieldFilters: FieldFilter[] = [];
  massiveActionSelected: string = '';
  massiveAccions: MassiveActions[] = [
    { key: 'close_reserve', enabled: false },
    { key: 'sync', enabled: false }
  ];

  constructor(
    private restService: RestService,
    public appService: AppService,
    private eventsService: EventsService,
    public loaderService: LoaderService,
    private dialog: MatDialog) { }

  ngOnInit() {

    this.getStockLockers();

    this.fieldFilters.push({
      name: 'status',
      type: 'select',
      multiple: false,
      value: 'OPEN',
      values: ['OPEN'],
      options: ['OPEN', 'RESERVED_FUTURE', 'RENOVATION', 'PENDING', 'RESERVED', 'CLOSED'],
      label: this.appService.getTraduccion('reserve.search.status')
    });
    this.fieldFilters.push({
      name: 'categoryId',
      type: 'category',
      multiple: false,
      value: '',
      values: [],
      options: [],
      label: 'Categoria'
    });
    this.fieldFilters.push({
      name: 'type',
      type: 'select',
      multiple: false,
      value: '',
      values: [],
      options: ['MANUAL', 'INPERSON', 'ONLINE'],
      label: this.appService.getTraduccion('reserve.search.reserveType')
    });
    this.fieldFilters.push({
      name: 'date',
      type: 'date',
      multiple: false,
      value: '',
      values: [],
      //values: [moment().subtract(1, 'M').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      options: null,
      label: this.appService.getTraduccion('reserve.search.date')
    });
    this.fieldFilters.push({
      name: 'customerId',
      type: 'number',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('reserve.search.customer')
    });
    this.fieldFilters.push({
      name: 'telephoneNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('reserve.search.phone')
    });
    this.fieldFilters.push({
      name: 'email',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('reserve.search.email')
    });
    this.fieldFilters.push({
      name: 'invoiceNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('reserve.search.invoiceNumber')
    });
    this.fieldFilters.push({
      name: 'ticketNumber',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: this.appService.getTraduccion('reserve.search.ticketNumber')
    });


    this.eventsService.subscribe('updatedFromServer', (result: any) => {
      Log.debug('updatedFromServer', result.body);
    });

    this.selection.changed.subscribe(rows => {
      if (rows.source.isEmpty()) {
        this.massiveAccions.forEach(accion => accion.enabled = false);
      } else {
        this.massiveAccions.forEach(accion => accion.enabled = true);
      }
    });

    this.search();
  }

  
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy() {
    this.eventsService.destroy('updatedFromServer');
  }
  

  getStockLockers() {
    this.loaderService.setLoading(true);
    this.restService.findFreeLocker().subscribe((stock: StockModel) => {
      if (stock != undefined) {
        this.loaderService.setLoading(false);
        this.appService.setCurrentStock(stock);
      }
    });
  }

  isToday(order?:ReservationModel):boolean {
    if(order){
      const today = new Date()
      const startTime = new Date(order?.startTime);
      return today.toDateString() === startTime.toDateString();
    }else{
      return false;
    }
  }

  /** Header checkbox helpers */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.validationAction(row) && this.selection.select(row));
  }


  openManualReserve() {
    this.dialog.open(ReservationManualModalContent, {
      panelClass: 'responsive-dialog',
    });
  }

  openDetailModal(reservation?: ReservationModel) {
    const isNew: boolean = reservation?.uuid == undefined ? true : false;
    const uuid:string = reservation?.uuid;
    let dialogRef = this.dialog.open(ReservationModalContent, {
      panelClass: 'responsive-dialog',
      data: { uuid: uuid, isNew: isNew }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.search());
  }

  /**
   * 
   * @param event example: { length: 155, pageIndex: 1, pageSize: 50, previousPageIndex: 0 }
   */
  onPageChange(event: PageEvent) {
    const page = event ? event.pageIndex : this.pageIndex;
    const size = event ? event.pageSize : this.pageSize;

    this.getOrdersMerged({ action: 'PAGE_CHANGE', page: page, size: size });
  }

  onClickMassiveAction(value: string) {
    if (value == 'close_reserve') {
      if (!confirm("Esta seguro de realizar la acción?")) {
        Log.trace("Implement delete functionality here");
        return;
      }
      this.closeOrderMassive();
      this.search();

    } else if (value == 'sync') {
      if (!confirm("Esta seguro de realizar la acción?")) {
        Log.trace("Implement delete functionality here");
        return;
      }
      this.syncReservationMassive();

    } else {
      alert('error, acción no seleccionada');
    }
  }

  async closeOrderMassive(){
    const orderSelected = this.selection.selected;
    const promises = orderSelected.map(o => this.closeReservation(o.uuid));
    await Promise.all(promises); // todas a la vez
    Log.debug('Todas cerradas (en paralelo)');
    this.appService.showSuccessToast(Constants.MSG_SUCCESS);
  }

  async syncReservationMassive(){
    const orderSelected = this.selection.selected;
    const promises = orderSelected.map(o => this.syncReservation(o.uuid));
    await Promise.all(promises); // todas a la vez
    Log.debug('Todas synced (en paralelo)');
    this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    this.selection.clear();
  }

  onChangeMassiveActionSelected(value: string) {
    this.massiveActionSelected = value;
  }

  validationAction(reservation: ReservationModel): boolean {
    if (this.massiveActionSelected == 'close_reserve') {
      return reservation.status == 'OPEN';
    } else if (this.massiveActionSelected == 'sync') {
      return true;
    } else {
      return false;
    }
  }

  mapAsFilters(fieldFilters: FieldFilter[]) {
    let filters = [];
    let map = [];
    map['date'] = OperatorFilterEnum.BETWEEN;
    map['datetime'] = OperatorFilterEnum.BETWEEN;
    map['time'] = OperatorFilterEnum.BETWEEN;
    map['text'] = OperatorFilterEnum.EQUALS;
    map['select'] = OperatorFilterEnum.EQUALS;
    map['number'] = OperatorFilterEnum.EQUALS;
    map['category'] = OperatorFilterEnum.EQUALS;

    for (let fieldFilter of fieldFilters) {
      if ((fieldFilter.value != null && fieldFilter.value != '') || (fieldFilter.values != null && fieldFilter.values.length > 0)) {
        if (fieldFilter.name == 'date') {
          filters.push({
            field: 'startTime',
            operator: OperatorFilterEnum.LESS_OR_EQUAL_THAN,
            value: fieldFilter.values[1] + " 23:59:59",
            values: []
          });
          filters.push({
            field: 'endTime',
            operator: OperatorFilterEnum.GREATER_OR_EQUAL_THAN,
            value: fieldFilter.values[0] + " 00:00:00",
            values: []
          });
        } else {
          filters.push({
            field: fieldFilter.name,
            operator: map[fieldFilter.type],
            value: fieldFilter.value,
            values: fieldFilter.values
          });
        }

      }
    }
    return Utils.generateFilters(filters);
  }

  search() {
    this.getOrdersMerged();
  }

  getOrdersMerged({ page = this.pageIndex, size = this.pageSize, action = null }: { page?: number; size?: number; action?: string; } = {}) {
    this.state = 'loading';
    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + page + '&size=' + size;

    this.restService.getOrdersMerged(filters + sort + pageSize).subscribe(result => {
      console.log('getOrdersMerged', result);
      this.state = 'loaded';
      this.dataSource.data = result.content;
      this.totalElements = result.totalElements;     // total global
      this.pageSize = result.pageSize;               // tamaño actual
      this.pageIndex = result.pageNumber;            // índice actual
      this.selection.clear();
    }, (err => {
      this.state = 'error';
      this.dataSource.data = [];
      this.totalElements = 0;
      this.selection.clear();
    }));
  }

  get visibleReservations(): number {
    return this.dataSource.data?.length || 0;
  }

  get activeFilters(): FieldFilter[] {
    return this.fieldFilters.filter(filter =>
      (filter.value != null && filter.value !== '') ||
      (filter.values != null && filter.values.length > 0)
    );
  }

  get activeFiltersCount(): number {
    return this.activeFilters.length;
  }

  getFilterDisplayValue(filter: FieldFilter): string {
    if ((filter.type === 'date' || filter.type === 'datetime' || filter.type === 'time') && filter.values?.length) {
      return filter.values.filter(Boolean).join(' - ');
    }

    if (filter.type === 'select' && filter.options?.length) {
      const option = filter.options.find((current: any) => {
        if (typeof current === 'object' && current !== null) {
          return current.value === filter.value;
        }

        return current === filter.value;
      });

      if (option && typeof option === 'object' && option !== null) {
        return option.label;
      }
    }

    if (filter.values?.length) {
      return filter.values.filter(Boolean).join(', ');
    }

    return filter.value;
  }

  async closeReservation(uuid: string) {
  // Si el servicio REST devuelve Observable:
    await firstValueFrom(this.restService.closeOrder(uuid));
  }

  async syncReservation(uuid: string) {
  // Si el servicio REST devuelve Observable:
    await firstValueFrom(this.restService.syncReservation(uuid));
  }

  getReservationStatusTone(status?: string): DataTableBadgeTone {
    switch (status) {
      case 'OPEN':
      case 'RESERVED':
      case 'RESERVED_FUTURE':
        return 'success';
      case 'PENDING':
      case 'RENOVATION':
        return 'warning';
      case 'CLOSED':
        return 'neutral';
      default:
        return 'primary';
    }
  }

  getReservationTypeTone(type?: string): DataTableBadgeTone {
    switch (type) {
      case 'INPERSON':
        return 'success';
      case 'ONLINE':
        return 'info';
      case 'MANUAL':
        return 'primary';
      default:
        return 'neutral';
    }
  }


  setColor(reservation: any) {
    let min = 100;
    let max = 256;
    var red = Math.floor(Math.random() * (max - min) + min);
    var green = Math.floor(Math.random() * (max - min) + min);
    var blue = Math.floor(Math.random() * (max - min) + min);
    var newColor = "rgb(" + red + "," + green + "," + blue + ")";
    reservation.color = newColor;
  }

}



@Component({
  selector: 'app-reservation-modal-content',
  templateUrl: './reservation-modal.component.html',
  styleUrls: ['./reservation-modal.component.scss']
})
export class ReservationModalContent implements OnInit, OnChanges {

  reservation: ReservationDetailsDto;
  reservationLinesDataSource = new MatTableDataSource<any>([]);
  isNew: boolean;
  uuid: string = '';
  extras: any = '';
  tracks: any = {};
  show: string = 'reserve';
  displayedColumns: string[] = ['startTime', 'endTime', 'status', 'amountPeriod', 'subtotal'];
  tracksPageSize = 3;
  tracksPageIndex = 0;

  typePasswordOptions: string[] = ['USER', 'LOCKER'];

  periods: CalculatePeriods = {
    periodToPay: 0,
    pperiodPaid: 0,
    totalToPay: 0,
    totalPaid: 0
  };

  boxId:number = 0;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ReservationModalContent>,
    @Inject(MAT_DIALOG_DATA) public data: { uuid: string; isNew: boolean },
    private eventsService: EventsService,
    private restService: RestService,
    public appService: AppService
  ) {

  }

  ngOnInit(): void {
    //this.order = this.data.order;
    //this.boxId = this.data.order.lockerId;
    this.isNew = this.data.isNew;

    if (this.data.isNew) {
      this.show = 'app';
    } else {
      this.uuid = this.data.uuid;
      this.getReservation();
    }

    this.eventsService.subscribe('updatedModalOrder', (result: any) => {
      console.log('updatedModalOrder', result);
      //this.getOrderLockerApp();
    });

  }

  ngOnDestroy() {
    this.eventsService.destroy('updatedModalOrder');
  }

  ngOnChanges(changes: SimpleChanges) {
    Log.debug('OrderModalContent ngOnChanges', changes);
  }


  getReservation(){
    this.restService.getReservation(this.uuid).subscribe((result: ReservationDetailsDto) => {
      this.reservation = result;
      this.boxId = this.reservation.lockerId;
      this.tracksPageIndex = 0;
      this.reservationLinesDataSource.data = this.reservationLines;
      this.getOrderLockerApp();
    });
  }

  refresh(){
    this.getReservation();
  }

  get reservationLines(): Array<{ line: OrderLineDto; originalIndex: number; displayOrder: number; }> {
    const lines = this.reservation?.lines || [];
    const total = lines.length;

    return lines.map((line, index) => ({
      line,
      originalIndex: index,
      displayOrder: total - index
    }));
  }

  get pagedReservationLines(): Array<{ line: OrderLineDto; originalIndex: number; displayOrder: number; }> {
    const start = this.tracksPageIndex * this.tracksPageSize;
    return this.reservationLines.slice(start, start + this.tracksPageSize);
  }

  onTracksPageChange(event: PageEvent) {
    this.tracksPageIndex = event.pageIndex;
    this.tracksPageSize = event.pageSize;
  }


  
  provisionalPasswordUpdated(value: any) {
    Log.debug('provisionalPasswordUpdated:' + value);
    const oldValue = structuredClone(this.reservation.lockerPassword);
    this.reservation.lockerPassword.provisionalPassword = value;
    this.changePasswordOrder(null, value, oldValue);
  }

  checkoutPasswordUpdated(value: any) {
    Log.debug('checkoutPasswordUpdated:' + value);
    const oldValue = structuredClone(this.reservation.lockerPassword);
    this.reservation.lockerPassword.checkoutPassword = value;
    this.changePasswordOrder(value, null, oldValue);
  }

  typePasswordUpdated(value: any) {
    Log.debug('typePasswordUpdated:' + value);
    this.reservation.lockerPassword.typePassword = value;
    this.updateOrder();
  }

  changePasswordOrder(checkoutPassword:string, provisionalPassword:string, oldValue:any){
    let pass = {
      checkoutPassword: checkoutPassword != null ? checkoutPassword : null,
      provisionalPassword: provisionalPassword != null ? provisionalPassword : null
    }
    this.restService.changePasswordOrder(this.uuid, pass).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    },err => {
      Log.debug(oldValue);
      this.reservation.lockerPassword = oldValue;
    });
  }

  lockerNumberUpdated(value: number) {
    Log.debug('lockerNumberUpdated:' + value);
    this.boxId = value;
    this.restService.changeBoxOrder(this.uuid, value).subscribe(result => {
      this.reservation.lockerId = value;
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    }
    ,(err) =>{
      console.error('erradada', err, this.reservation.lockerId);
      this.boxId = this.reservation.lockerId;
    });
  }

  openLocker() {
    if (!this.boxId) {
      return;
    }

    if (!confirm("Esta seguro de realizar la acciÃ³n?")) {
      return;
    }

    this.restService.lockerOpenManual(this.boxId).subscribe(result => {
      this.appService.showSuccessToast('OPEN_LOCKER');
    }, () => {
      this.appService.showDangerToast('ERROR_OPEN_LOCKER');
    });
  }

  close() {
    this.dialogRef.close();
  }

  getOrderLockerApp() {
    //this.extras = JSON.stringify(this.order.extra);
    if (this.reservation && this.reservation.uuid != null && this.reservation.status == 'OPEN') {
      this.calculatePeriods(this.reservation.uuid);
    }
  }

  openManualReserve() {
    const dialogRef = this.dialog.open(ReservationManualModalContent, {
      panelClass: 'responsive-dialog',
      data: { reservation: this.reservation }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) =>{
      if(data?.updated){
        this.dialogRef.close({updated:true});
        this.refresh();
      }
    });
  }

  openDataPayment(line: OrderLineDto, index: number) {
    const diff = this.reservation['diff']?.lines !== undefined && this.reservation['diff']?.lines[index] !== undefined
      ? this.reservation['diff']?.lines[index]?.payment
      : {};
    const dialogRef = this.dialog.open(PaymentModalContent, {
      panelClass: 'responsive-dialog',
      data: { line: line, diff: diff, catCode:new Map().set(this.reservation.categoryId, this.reservation.categoryCode) }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) =>{
      if(data?.updated){
        this.refresh();
      }
    });
  }

  openDataRefund(refund: RefundModel, index: number) {
    const diff = this.reservation['diff']?.lines !== undefined && this.reservation['diff']?.lines[index] !== undefined
      ? this.reservation['diff']?.lines[index]?.payment.refund
      : {};
    this.dialog.open(RefundModalContent, {
      panelClass: 'responsive-dialog',
      data: { refund: refund, diff: diff }
    });
  }

  openDataHistorical(orderUuid: any) {
    this.dialog.open(ActivityModalContent, {
      panelClass: 'responsive-dialog',
      disableClose: true,
      data: { orderUuid: orderUuid }
    });
  }

  reopenReserve() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.reopenReserve(this.reservation.uuid).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  calculatePeriods(orderUuid: string) {
    console.log('calculatePeriods', orderUuid);
    //if(!this.appService.clientSelected?.online){
    //  return;
    //}
    this.restService.calculatePeriods(orderUuid).subscribe(result => {
      this.periods = result;
    });
  }

  colorOrderTrack() {
    for (let orderTrack of this.reservation.lines) {
      orderTrack['color'] = Utils.generateColor(orderTrack.payment.uuid);
    }
  }

  updateOrder() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.updateOrder(this.reservation).subscribe(result => {
      console.log('updateOrder', result);
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  changeEmailReservation(value: string) {
    let newEmail = value;
    if (newEmail == null) {
      return;
    }

    this.restService.updateEmailReservation(this.reservation.uuid, newEmail).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.refresh();
    });
  }


  changePhoneReservation(value: string) {
    let newEmail = value;
    if (newEmail == null) {
      return;
    }

    this.restService.updatePhoneReservation(this.reservation.uuid, newEmail).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.refresh();
    });
  }


  closeReservation() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.closeOrder(this.reservation.uuid).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({updated:true});
    });
  }

  /*
  executeSync(data: any) {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    let direction = 'toserver';
    if (this.order.sync == 'SYNC_NEED_UP') {
      direction = 'toserver';
    } else if (this.order.sync == 'SYNC_NEED_DOWN') {
      direction = 'toapp';
    }
    this.restService.executeSync(direction, data).subscribe(result => {
      console.log(direction, result);
    });
  }*/

  syncReservation() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.syncReservation(this.reservation.uuid).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.refresh();
    }, (err)=>{
      this.showErrorSync(err.error);
      this.appService.showSuccessToast(Constants.MSG_DANGER);
    });
  }

  snapshotReservation() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.snapshotReservation(this.reservation.uuid).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.refresh();
    }, (err)=>{
        this.showErrorSync(err);
        this.appService.showSuccessToast(Constants.MSG_DANGER);
    });
  }


  showErrorSync(result:any){
    const reservation = result.reservation;
    const orders = result.orders;
    if(reservation != null){
      const textOrign = this.appService.getTraduccion("reserve.action.sync.error.reservation");
      const text = textOrign.replace("{}", reservation.uuid).replace("{}", reservation.error);
      this.appService.showSuccessToast(text);
    }
    
    if(orders != null){
      orders.forEach((element:any) => {
        const textOrign = this.appService.getTraduccion("reserve.action.sync.error.order");
        const text = textOrign.replace("{}", element.uuid).replace("{}", element.error);
        this.appService.showSuccessToast(text);
      });
    }
  }

}


@Component({
  selector: 'app-payment-modal-content',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss']
})
export class PaymentModalContent implements OnInit {
  line: OrderLineDto;
  diff: any;
  public isCollapsed = true;


  constructor(
    public dialogRef: MatDialogRef<PaymentModalContent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { line: OrderLineDto; diff: any, catCode: Map<number, string> },
    private restService: RestService,
    public appService: AppService,
    public configService: ConfigService) { }

  ngOnInit() {
    this.line = this.data.line;
    this.diff = this.data.diff;

    console.log('line', this.line);
    console.log('diff', this.diff);
  }

  close() {
    this.dialogRef.close();
  }

  getCategoryCode(id:number):string{
    return this.data?.catCode.has(id) ? this.data.catCode.get(id) : String(id);
  }

  downloadTicket() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.getTicketBase64(this.line.payment.uuid, this.line.payment.dataTicket.ticketNumber).subscribe(result => {
      console.log('getTicketBase64', result);

      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<head><title>Ticket " + this.line.payment.ticketNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )

    });
  }

  downloadFactura() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.getInvoiceBase64(this.line.payment.invoice.invoiceNumber).subscribe(result => {
      console.log('getInvoiceBase64', result);

      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<head><title>Invoice " + this.line.payment.dataTicket.ticketNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )

    });
  }

  generateTicket() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.generateTicket(
      this.line.payment.uuid, 
      this.line.payment.ticketNumber, 
      this.line.payment.dataTicket
    ).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    },err=> this.appService.showSuccessToast(Constants.MSG_DANGER));
  }

  regenerateQrTicket() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.regenerateQrTicket(this.line.payment.uuid, this.line.payment.ticketNumber).subscribe(result => {
      console.log('ticket_regenerateTicket-ticket', result);
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  printTicket() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.printTicket(this.line.payment.uuid, this.line.payment.ticketNumber).subscribe(result => {
      console.log('printTicket', result.file);
    });
  }

  openSend(){
    this.dialog.open(SenderModalContent, {
      panelClass: 'responsive-dialog',
      data: {uuid: this.line.orderUuid }
    });
  }

  
  resendEmail() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.resendEmail(this.line.orderUuid).subscribe(result => {
      console.log('resendEmail', result);
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
    });
  }

  goToViewer(orderUuid:string) {
    const url = this.configService.settings.reserveDomain;
    window.open(url + '/reserve/visor?code=' + orderUuid, '_blank');
  }

  cancelOrRefundPayment() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.paymentCancel(this.line.payment.uuid).subscribe(result => {
      console.log('paymentCancel', result);
      if(result){
        result.forEach(element => {
          this.appService.showSuccessToast(this.appService.getTraduccion(element));
        });
      }else{
        this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      }
      this.dialogRef.close({updated:true});
    });
  }

  capturePayment() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.paymentCapture(this.line?.payment?.uuid).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({updated:true});
    });
  }


  openDialogTicketRawData() {
    this.dialog.open(SimpleDialogComponent,
      {
        data: {
          title: this.appService.getTraduccion('ticket.rawData'),
          content: this.line.payment.dataTicket,
        }
      }
    );
  }

}



@Component({
  selector: 'app-refund-modal-content',
  templateUrl: './refund-modal.component.html',
  styleUrls: ['./refund-modal.component.scss']
})
export class RefundModalContent implements OnInit {
  @Input() refund: RefundModel;
  @Input() diff: any;
  public isCollapsed = true;


  constructor(
    public dialogRef: MatDialogRef<PaymentModalContent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { refund: PaymentModel; diff: any },
    private restService: RestService,
    public appService: AppService) { }

  ngOnInit() {
    this.refund = this.data.refund;
    this.diff = this.data.diff;

    console.log('refund', this.refund);
    console.log('diff', this.diff);
  }

  close() {
    this.dialogRef.close();
  }

  downloadTicket() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.getTicketBase64(this.refund.uuid, this.refund.ticketNumber).subscribe(result => {
      console.log('getTicketBase64', result);

      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<head><title>Ticket " + this.refund.ticketNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )

    });
  }

  downloadFactura() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.getInvoiceBase64(this.refund.invoice.invoiceNumber).subscribe(result => {
      console.log('getInvoiceBase64', result);

      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<head><title>Invoice " + this.refund.ticketNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )

    });
  }

  generateTicket() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.generateTicket(this.refund.uuid, this.refund.ticketNumber, this.refund.dataTicket).subscribe(result => {
      console.log('order_generate-ticket', result);
      if (result) {
        this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      } else {
        this.appService.showSuccessToast(Constants.MSG_DANGER);
      }
      /*
      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<head><title>Invoice " + this.payment.invoice.invoiceNumber + "</title></head>" +
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(result.file) + "'></iframe>"
      )
        */

    });
  }

  cancelOrRefundPayment() {
    if (!confirm("Quieres ejecutar?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.paymentCancel(this.refund.uuid).subscribe(result => {
      console.log('paymentCancel', result);
      if(result){
        result.forEach(element => {
          this.appService.showSuccessToast(this.appService.getTraduccion(element));
        });
      }else{
        this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      }
      
    });
  }


  openDialogTicketRawData() {
    this.dialog.open(SimpleDialogComponent,
      {
        data: {
          title: this.appService.getTraduccion('ticket.rawData'),
          content: this.refund.dataTicket,
        }
      }
    );
  }
}


@Component({
  selector: 'app-activity-modal-content',
  templateUrl: './activity-modal.component.html',
  styleUrls: ['./activity-modal.component.scss']
})
export class ActivityModalContent implements OnInit, OnChanges {
  orderUuid: string;
  lockerId: number;
  activities: ActivityModel[] = [];
  isRefreshing = false;
  displayedColumns: string[] = ['description', 'createdAt', 'status', 'who'];

  constructor(
    private eventsService: EventsService,
    public dialogRef: MatDialogRef<ActivityModalContent>,
    @Inject(MAT_DIALOG_DATA) public data: { orderUuid: string; },
    private restService: RestService,
    public appService: AppService
  ) { }

  ngOnInit() {
    console.log('activities', this.activities);
    this.orderUuid = this.data.orderUuid;
    this.showActivities(this.orderUuid);
    this.eventsService.subscribe('updatedFromServer', (result: any) => {
      console.log('updatedFromServer', result.body);
      this.showActivities(this.orderUuid);
    });
  }

  ngOnDestroy() {
    this.eventsService.destroy('updatedFromServer');
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('ActivityModalContent ngOnChanges', changes);
    this.showActivities(this.orderUuid);
  }

  activityRowClass = (row: ActivityModel) => row?.domain?.toLowerCase?.() || '';


  activityDescription(domain:string, action:string):string {
    const key = 'activity.'+domain+'.'+action;
    const value = this.appService.getTraduccion(key);
    if(key == value){
      return action;
    }
    return value;
  }


  showActivities(orderUuid: string) {
    this.isRefreshing = true;
    this.restService.getActivities(orderUuid).subscribe(result => {
      this.activities = result;
      for (let activity of this.activities) {
        this.lockerId = activity.metadata != null ? activity.metadata['lockerId'] : null;
      }
      this.isRefreshing = false;
    }, () => {
      this.isRefreshing = false;
    });
  }

  close() {
    this.dialogRef.close();
  }

}
export interface CategoryFlat {
  id: number;
  name: string;
  level: number;
  expandable: boolean;
}

@Component({
  selector: 'app-reservation-manual-modal-content',
  templateUrl: './reservation-manual.component.html',
  styleUrls: ['./reservation-manual.component.scss']
})
export class ReservationManualModalContent implements OnInit, OnDestroy {

  currentStock$: Subscription;
  state: 'idle' | 'loading' | 'loaded' | 'error' = 'idle';
  form!: FormGroup;
  displayedColumns: string[] = ['key', 'nLocker', 'discount', 'precio', 'precioFinal', 'actions'];
  orderUuid:string;
  items: ItemCart[] = [];
  startDate: string;
  endDate: string;
  userData: UserData;
  infoCart: InfoCart = {
    startDate: null,
    endDate: null,
    items: [],
    total: 0,
    tax: 0,
    resumen: [],
    address: '',
    kioskAddress: ''
  };

  flatCategories:CategoryFlat [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ReservationManualModalContent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      reservation: ReservationModel,
      categories: CategoryModel[]
    },
    private restService: RestService,
    public appService: AppService
  ) {

  }

  ngOnInit(): void {
    this.iniForm();
    const reservation = this.data?.reservation;
    if (reservation != null) {
      this.form.get('provisionalPassword').setValue(reservation.lockerPassword.provisionalPassword);
      this.form.get('checkoutPassword').setValue(reservation.lockerPassword.checkoutPassword);
      this.form.get('typePassword').setValue(reservation.lockerPassword.typePassword);

      this.userData = reservation?.lines[0]?.order?.cart?.userData;
      this.orderUuid = reservation.uuid;
      this.items.push({
        reservationUuid: reservation.uuid,
        categoryId: reservation.categoryId
      });
    }

    this.currentStock$ = this.appService.currentStock$.subscribe((stock:StockModel)=>{
      let level:number = 0;
      this.flatCategories = this.flatten(stock.items, level);
    });
  }

  ngOnDestroy() {
    this.currentStock$?.unsubscribe();
  }

  iniForm() {
    this.form = this.fb.group({
      dateRange: this.fb.group({
        fromDate: ['', [Validators.required]],
        toDate: ['', [Validators.required]],
        fromTime: ['', [Validators.required]],
        toTime: ['', [Validators.required]]
      }),
      provisionalPassword: ['', [Validators.minLength(4), Validators.maxLength(4)]],
      checkoutPassword: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      typePassword: ['LOCKER'],
      isFree: [false],
      discountCode: [''],
      customerId: [''],
      selectedCategoryItem: ['', []]
    });

    this.form.get('provisionalPassword')?.disable();

    // Si marca "Gratis", limpiar y bloquear descuento
    this.form.get('isFree')?.valueChanges.subscribe(free => {
      const discountCtrl = this.form.get('discountCode');
      if (free) {
        discountCtrl?.disable();
        discountCtrl?.setValue('_FREE');
      } else {
        discountCtrl?.reset();
        discountCtrl?.enable();
      }
    });

    this.form.get('selectedCategoryItem')?.valueChanges.subscribe((value:CategoryFlat) => {
      console.log("selectedCategoryItem", value);
      if (value.name.includes('KEY')) {
          this.form.get('provisionalPassword')?.enable();
        } else {
          this.form.get('provisionalPassword')?.disable();
        }
    });
  }

  onFormReady(childForm: FormGroup) {
    this.form.setControl('dateRange', childForm);
    this.form.get('dateRange')?.setValidators([Validators.required]);

    const reservation = this.data?.reservation;
    if(reservation){
      const fromDate = new Date(reservation?.startTime);
      const toDate = new Date(reservation?.endTime);
      const fromTime = `${String(fromDate.getHours()).padStart(2, '0')}:${String(fromDate.getMinutes()).padStart(2, '0')}`;
      const toTime = `${String(toDate.getHours()).padStart(2, '0')}:${String(toDate.getMinutes()).padStart(2, '0')}`;
      this.form.get('dateRange')!.patchValue({ fromDate: toDate }, { emitEvent: false });
      this.form.get('dateRange')!.patchValue({ toDate: toDate }, { emitEvent: false });
      
      setTimeout(()=>{
        this.form.get('dateRange')!.patchValue({ fromTime: toTime }, { emitEvent: true });
        this.form.get('dateRange')!.patchValue({ toTime: toTime }, { emitEvent: true });
      }, 1000);
      this.showCart();
    }
  }

  get isValidateForm(): boolean{
    return this.form?.valid && this.items?.length > 0;
  }

  get isExtensionMode(): boolean {
    return !!this.data?.reservation;
  }

  get dialogModeTitle(): string {
    return this.isExtensionMode ? 'Ampliacion de reserva' : this.appService.getTraduccion('reserve.manual');
  }

  get dialogModeSubtitle(): string {
    return this.isExtensionMode
      ? 'Configura nuevas fechas y revisa el carrito antes de ampliar la reserva.'
      : 'Configura fechas, categoria, descuentos y revisa el carrito antes de generar la reserva.';
  }

  get isValidateItemSelected(): boolean{
    return !this.form.get('selectedCategoryItem')?.disabled || this.form.get('selectedCategoryItem')?.valid;
  }
  
  get isEnableProvisionalPassword(): boolean {
    return this.form.get('provisionalPassword')?.enabled || false;
  }

  controlSelectedTypeItem(){
    if(this.items.length > 0){
      this.form.get('selectedCategoryItem')?.disable();
    }else{
      this.form.get('selectedCategoryItem')?.enable();
    }
  }

  onFormUpdated({ start, end }: { start?: string; end?: string; } = {}) {
    console.log('onFormUpdated', start, end);
    this.startDate = start;
    this.endDate = end;
  }

  getLocalDateTime(datetime: any): string {
    let now = new Date();
    if (datetime != null) {
      now = new Date(datetime);
    }
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  }

  addItem(category: CategoryFlat) {
    this.items.push({
      categoryId: category.id
    });
    //this.controlSelectedTypeItem();
    this.showCart();
  }

  removeItem(item: ItemInfoCart) {
    console.log(item);
    const index = this.items.findIndex(i => (i.categoryId == item.categoryId) || (i.reservationUuid && item.reservationUuid  && i.reservationUuid == item.reservationUuid));
    this.items.splice(index, 1);
    this.controlSelectedTypeItem();
    this.showCart();
  }

  //value=2025-04-01T00:00
  mapDatetime(value: string) {
    let m = moment(value);
    return m.format('DD-MM-YYYY HH:mm');
  }

  flatten(categories: Type[], level = 0): CategoryFlat[] {
    let result: CategoryFlat[] = [];
    for (const cat of categories) {
      result.push({
        id: cat.id,
        name: cat.literals[AppService.langSel.name].name,
        level,
        expandable: !!cat.items?.length
      });

      if (cat.items) {
        result = result.concat(this.flatten(cat.items, level + 1));
      }
    }
    return result;
  }

  getCartFromForm(): Cart {
    return {
      items: this.items,
      startDate: this.startDate,
      endDate: this.endDate,
      userData: {
        id: null,
        name: '',
        email: '',
        discountCode: this.form?.get('discountCode')?.value || '',
        extension: '',
        telephoneNumber: '',
        agreement: false,
        insurance: false,
        langCode: 'ES',
        passwordLocker: {
          provisionalPassword: this.form?.get('provisionalPassword')?.value || '',
          checkoutPassword: this.form?.get('checkoutPassword')?.value || '',
          typePassword: TypePassword.LOCKER
        }
      }
    };
  }

  showCart() {
    this.state = 'loading';
    const cart = this.getCartFromForm();
    this.restService.infoCart(cart).subscribe((result: InfoCart) => {
      this.state = 'loaded';
      this.infoCart = result;
    }, err => this.state = 'error');
  }

  createReservation() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    const cart = this.getCartFromForm();
    this.restService.createOrder(cart).subscribe(result => {
      console.log('createOrder', result);
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({updated: true});
    }, err => this.state = 'error');
  }


  close() {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'app-sender-modal-content',
  templateUrl: './sender-modal.component.html',
  styleUrls: ['./sender-modal.component.scss'],
  standalone: true,
  imports: [SharedModule, AdminSenderPageModule]
})
export class SenderModalContent implements OnInit {

  constructor(
    private eventsService: EventsService,
    public dialogRef: MatDialogRef<ActivityModalContent>,
    @Inject(MAT_DIALOG_DATA) public data: { uuid: string; },
    private restService: RestService,
    public appService: AppService
  ) { }

  ngOnInit() {
    
  }

  ngOnDestroy() {
   
  }

  close() {
    this.dialogRef.close();
  }

}
